// Header.tsx
'use client';

import { Button } from '@/components/ui/Button/Button';
import useDevice from '@/hooks/useDevice';
import "@/styles/sections/sections.scss";
import { useRouter } from 'next/navigation';
import { useLanguage } from '@/context/LanguageContext';

const HeroSection = () => {
  const router = useRouter();
  const { t } = useLanguage();
  const { locale } = useLanguage();
  const isKorean = locale === "ko";
  const imageSrc = isKorean ? "/images/sections/main-img.png" : "/images/sections/main-img-en.png";
  return (
    <div className="hero-section">
      <div className='title-container'>
        <div className='headline'>
          <p className='title'>
            {t.hero.title}
          </p>
          <p className='subtitle'>
            {t.hero.subtitle}
          </p>
        </div>
        <div className='button-container'>
          <Button
            type='tertiary-black'
            size='large'
            icon='none'
            otherClassName='btn-radius-100'
            label={t.hero.viewIntro}
            onClick={() => { window.open('https://public.relate.so/p/docs/gvzlq85v3aqtlt8a', '_blank') }}
          />
          <Button
            type='primary2'
            size='large'
            icon='none'
            otherClassName='btn-radius-100'
            label={t.hero.contactUs}
            onClick={() => window.open('https://public.relate.so/p/forms/pzst8jlmfdxtahcw', '_blank')}
          />
        </div>
      </div>
      <div className='image-container'>
        <img  src= {imageSrc} alt="hero-image" />
      </div>
    </div>
  );
};

export default HeroSection;